import { PageRef } from 'providers/page-ref';

export type TestUiNutrientsPageParams = {};

export const ITestUiNutrientsPage: PageRef<TestUiNutrientsPageParams, void> = {
  pageName: 'TestUiNutrientsPage',
} as PageRef<TestUiNutrientsPageParams, void>;
